import * as React from "react";
const SvgDisconnected = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { stroke: "currentColor", strokeWidth: 2 },
        React.createElement("path", { d: "M6.876 6.876A6 6 0 0 1 18 10a5 5 0 0 1 1.703 9.703M16 20H7A6 6 0 0 1 4.5 8.544M.707.707l22.586 22.586" }))));
export default SvgDisconnected;
